import React from 'react'
import { type Control, useWatch } from 'react-hook-form'

import {
  IconButton,
  type IconButtonProps,
} from '~/components/elements/IconButton'
import { VStack } from '~/components/elements/VStack'

import { type FilterItem, type InputValues } from '../utils'

type RenderInputParams<TCategory extends string> = {
  filterGroupIndex: number
  filterIndex: number
  category: TCategory
}

export type FilterInputProps<
  TFilterItem extends FilterItem<TCategory>,
  TCategory extends string,
> = {
  control: Control<InputValues<TFilterItem, TCategory>>
  filterGroupIndex: number
  filterIndex: number
  onDelete: (filterIndex: number) => void
  renderInput: (params: RenderInputParams<TCategory>) => React.ReactNode
}

export const FilterInput = <
  TFilterItem extends FilterItem<TCategory>,
  TCategory extends string,
>({
  control,
  filterGroupIndex,
  filterIndex,
  onDelete,
  renderInput,
}: FilterInputProps<TFilterItem, TCategory>) => {
  const handleDeleteButtonClick = React.useCallback<
    EH<IconButtonProps, 'onClick'>
  >(() => {
    onDelete(filterIndex)
  }, [filterIndex, onDelete])

  // @ts-expect-error
  const { category }: TFilterItem = useWatch({
    control,
    // @ts-expect-error
    name: `filterGroups.${filterGroupIndex}.${filterIndex}`,
  })

  return (
    <VStack align="end" backgroundColor="grayF3" padding={4} spacing={2}>
      <IconButton
        buttonStyle="light"
        fillMode="flat"
        icon="delete"
        onClick={handleDeleteButtonClick}
      />

      {renderInput({ category, filterGroupIndex, filterIndex })}
    </VStack>
  )
}
